import type { Environment } from './environment.d';

// Environment setup for production
export const environment: Environment = {
  production: true,

  apiUrl: 'https://admin-prod.theselfwish.com/api',
  siteUrl: 'https://theselfwish.com',
  eventImageUrl: 'https://theselfwish-media-prod.s3.us-east-2.amazonaws.com/event/image/event_list',
  profileImageUrl: 'https://theselfwish-media-prod.s3.us-east-2.amazonaws.com/profile',
  categoryImageUrl: 'https://theselfwish-media-prod.s3.us-east-2.amazonaws.com/images',
  groupImageUrl: 'https://theselfwish-media-prod.s3.us-east-2.amazonaws.com/group',
  golfCourseImageUrl: 'https://theselfwish-media-prod.s3.us-east-2.amazonaws.com',
  vesion: "1.0.0-web",
// Google Maps API Configuration
googleMaps: {
  apiKey: 'AIzaSyCzWbLCVICRTn5WB__YQBZSHo2oqNbkI-k',
  libraries: ['places'],
  language: 'en'
},

  // Add your actual VAPID key here from Firebase Console
  vapidKey: 'BA2RuZa8C2zF5RA53BNMPRmB3hCv1PjP0wh5W8PEgI6Dm4HgN7od7kI3J6S8NKf9-RC11tlWxeJ9vs03jgOEc6I',

  recaptcha: {
    siteKey: '6LduY3gnAAAAAL1yIObtL8eJFMDN_gpWNxxw1YXd',
  },

  giphyApiKey: 'Ucd3X3pgL0m93eDClK5YjGrrjGSoQEsQ',

  zoom: {
    // sdkKey: 'Eb4_FClZT2Gfc32nqUtgyA',
    // sdkSecretKey: 'xVfQcMCwOZ7GK18N0bEKDTWvSUw26ozj', // ❗ see note below
    sdkKey: 'Eb4_FClZT2Gfc32nqUtgyA',
    sdkSecretKey: 'xVfQcMCwOZ7GK18N0bEKDTWvSUw26ozj',
  },

  facebookConfig: {
    clientId: '765790848698100',
    clientSecret: '1008936b494df7a29d2e5eaa74f6618e',
    redirectURI: 'fb765790848698100://authorize',
    state: 'origin:web',
    scope: 'email,public_profile',
  },

  // Firebase Details for Web Push Notifications
  firebaseConfig: {
    apiKey: "AIzaSyCzWbLCVICRTn5WB__YQBZSHo2oqNbkI-k",
    authDomain: "selfwish-410217.firebaseapp.com",
    projectId: "selfwish-410217",
    storageBucket: "selfwish-410217.firebasestorage.app",
    messagingSenderId: "898759621472",
    appId: "1:898759621472:ios:e7beec311e710d3050fc05", // iOS App ID
    measurementId: "G-TRSYSL90MW",
    vapidKey: 'BA2RuZa8C2zF5RA53BNMPRmB3hCv1PjP0wh5W8PEgI6Dm4HgN7od7kI3J6S8NKf9-RC11tlWxeJ9vs03jgOEc6I',
  },

  tiktokConfig: {
    clientId: 'awqpb3zy0ly4sra7',
    clientSecret: 'lDFx4QIhN30TbEzos2pZ3kMIwsCQug7H',
    redirectURI: 'https://theselfwish.com/auth/callback',
    state: 'origin:web',
  },

  googleClientId: '898759621472-2n4rd62eose6haaumkukelo3lop0q3ks.apps.googleusercontent.com',

  appleConfig: {
    clientId: 'com.theselfwish.auth',
    scope: 'name email',
    redirectURI: 'https://theselfwish.com/activities',
    state: 'origin:web',
  },

  reverb: {
    appKey: '739b63bf31a4dd65e4d7af',
    host: 'admin-prod.theselfwish.com', // Host should not include port, Echo adds it from the port value
    port: 443, // WSS uses default port 443 (as confirmed by successful connection test)
    wsPath: '/reverb',   // IMPORTANT
    scheme: 'https',
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: 'https://admin-prod.theselfwish.com/broadcasting/auth',
  },

  // Stripe Configuration
  stripePublishableKey: 'pk_test_51Sc3HrAVX0z2vW6NtKzKUygTeTjt8A9gnwUpZDdftKdAAXXjca5nHgVNURXOLJio8DoAeSgxyL7MliGUbqlLTwCo0039lUHSyh',
};